/**
 * Cross-tab de-duplication: every open tab receives the same realtime event, but only one tab
 * should play the sound / show the desktop notification. Tabs claim the message id inside a Web
 * Lock (when available) and record it in localStorage; the visible tab claims first.
 */

const STORAGE_KEY = 'natashu.chatAlerts.claimed';
const LOCK_NAME = 'natashu-chat-alert-claim';
const KEEP = 60;

function tryClaim(id: string): boolean {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const list = raw ? (JSON.parse(raw) as unknown) : [];
    const ids = Array.isArray(list) ? list.filter((x): x is string => typeof x === 'string') : [];
    if (ids.includes(id)) return false;
    ids.push(id);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids.slice(-KEEP)));
    return true;
  } catch {
    // Storage blocked (private mode): act alone.
    return true;
  }
}

/** Delay before claiming: the focused tab first, then visible, then hidden tabs. */
export function claimDelayMs(): number {
  if (document.visibilityState !== 'visible') return 450 + Math.random() * 150;
  return document.hasFocus() ? 0 : 150;
}

export async function claimAlert(id: string, delayMs = claimDelayMs()): Promise<boolean> {
  if (delayMs > 0) await new Promise((r) => setTimeout(r, delayMs));
  const locks = (navigator as Navigator & { locks?: LockManager }).locks;
  if (locks?.request) {
    try {
      return await locks.request(LOCK_NAME, async () => tryClaim(id));
    } catch {
      return tryClaim(id);
    }
  }
  return tryClaim(id);
}
